webpackJsonp([219818225411920],{

/***/ 1926:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PendingPackageDatum","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"required","type":{"kind":"SCALAR","name":"Truthy","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"type","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-pending-package-datum-3b31333548fb88a27fcc.js